import templateUrl from 'emun.salesrep/dashboard-totals-status.htm';
import basicController from "servicestack/basic.controller.properties";

class DashboardTotalsStatusController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.utils = utils;
		var context = $ctrl.context || 'rep';
    var queryCriteria = '';

		var filter = "RepId";
		if (context === 'vendor') {
			filter = 'VendorId';
		} else if (context === 'subrep') {
			filter = 'SubRepId';
    }
    if ($ctrl.insideSales === 'true') {
      queryCriteria = '&IsInsideSales=true';
    }
		//console.info('date r: ' + $ctrl.dateRange + ' : title: ' + $ctrl.title);
		//var dateRange = $ctrl.dateRange || "Last12Months";
		this.statuses = createAutoQuery({
      url: 'QueryCartsJoin.json?Fields=ERPStatus&Sum=GrandTotal&dateRange=YTD&' + filter + '=' + $ctrl.rep.id + '&GroupBy=ERPStatus',
			autoLoad: true,
			pageSize: 50
		});
	}
}

let DashboardTotalsStatus = {
	bindings: {
		rep: '<',
		context: '@',
		dateRange: '@',
    title: '@',
    insideSales: '@'
	},
  controller: DashboardTotalsStatusController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}


export default DashboardTotalsStatus;